import cl from 'classnames';
import * as React from 'react';
import { Transforms } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../../../figma/colors-v2';
import { deviceBreakpoints } from '../../../../../../hooks/useDeviceQuery.hook';
import { ButtonDelete } from '../../../shared/ButtonDelete';
import { BaseOutlineParagraphProps } from '../OutlineParagraphPlugin.types';

const Main = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr minmax(0, 24px);
  gap: 24px;
  align-items: center;
  padding-left: 16px;
  .idea-list {
    display: grid;
    gap: 8px;
    font-size: 18px;
    line-height: 28.8px;
    @media ${deviceBreakpoints.fromTablet} {
      font-size: 20px;
      line-height: 32px;
    }
  }
  .delete-button {
    margin-top: 32px;
    cursor: pointer;
    font-size: 24px;
    line-height: 0;
    color: ${colorsV2.black80};
    transition: all 0.2s ease;
    &:hover {
      color: ${colorsV2.primary100};
    }
    &:active {
      transform: scale(0.96);
    }
  }

  @media ${deviceBreakpoints.fromDesktop} {
    padding-left: 56px;
  }
`;

interface OutlineParagraphIdeaProps extends BaseOutlineParagraphProps {}

export const OutlineParagraphIdea = (props: OutlineParagraphIdeaProps) => {
  const { attributes, children, element, isReadOnly } = props;
  const editor = useSlateStatic();
  const rowIndex = ReactEditor.findPath(editor as any, element).pop();

  return (
    <Main {...attributes} className={cl('outline-paragraph-idea-element', element.id)}>
      <div className="idea-list">{children}</div>
      {!isReadOnly && rowIndex > 0 && (
        <ButtonDelete
          confirmDeleteTitle="Are you sure to delete this idea?"
          onConfirm={() => {
            const path = ReactEditor.findPath(editor as any, element);
            Transforms.removeNodes(editor, { at: path });
          }}
        />
      )}
    </Main>
  );
};
